module.exports = __webpack_public_path__ + "static/img/118.6c30c37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/118.png
// module id = rE8Y
// module chunks = 0